import React from "react";
import { Link } from "react-router-dom";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";

const PARAGRAPH_CLASS =
  "mt-3 text-sm leading-relaxed text-gray-700 md:text-base";

const BILDQUELLEN = [
  "© Tryfonov - Fotolia.com",
  "© Himmelssturm - Fotolia.com",
  "© beerkoff - Fotolia.com",
  "© WavebreakMediaMicro - Fotolia.com",
  "© khz - Fotolia.com",
  "© Blue-Fox - Fotolia.com",
  "© Yuri Arcurs - Fotolia.com",
  "© lolipep - Fotolia.com",
  "© pressmaster - Fotolia.com",
  "© foodmaster - Fotolia.com",
  "© Stefan Körber - Fotolia.com",
  "© arahan - Fotolia.com",
  "© buchachon - Fotolia.com",
  "© Nmedia - Fotolia.com",
  "© ferkelraggae - Fotolia.com",
  "© alphaspirit - Fotolia.com",
  "© olly - Fotolia.com",
  "© djama - Fotolia.com",
  "© Sergey Nivens - Fotolia.com",
  "© cindyphotos - Fotolia.com",
  "© Stefan Körber - Fotolia.com",
  "© Sashkin - Fotolia.com",
  "© fcarniani - Fotolia.com",
  "© natureimmortal - Fotolia.com",
  "© Photographee.eu- fotolia.com",
  "© Robert Kneschke - fotolia.com",
  "© MK-Photo - fotolia.com",
  "© magdal3na - fotolia.com",
  "© Kurhan - fotolia.com",
  "© Sergey Nivens - fotolia.com",
  "© Rawpixel.com - fotolia.com",
  "© Juice Images - fotolia.com",
  "© Syda Productions - fotolia.com",
  "© sdecoret - fotolia.com",
  "© k-loch - fotolia.com",
  "© Creativa Images- fotolia.com",
  "© KD Busch/compamedia GmbH",
];

const SECTIONS = [
  {
    id: "section-impressum-unternehmen",
    leftLabel: "UNTERNEHMEN",
    heading: "REPEXO GmbH & Co. KG",
    paragraphs: [
      "Am Hauptbahnhof 16",
      "60329 Frankfurt am Main",
      "",
      "Tel. + 49 (0)69 / 83 83 517-0",
      "Fax. + 49 (0)69/ 83 83 417- 17",
      "E-Mail: info@repexo.de",
      "",
      "Registergericht: Amtsgericht Frankfurt am Main",
      "Registernummer: HRA 52971",
    ],
  },
  {
    id: "section-impressum-gesellschafter",
    leftLabel: "GESELLSCHAFTER",
    heading: "Persönlich haftende Gesellschafterin",
    paragraphs: [
      "Persönlich haftende Gesellschafterin der REPEXO GmbH & Co. KG:",
      "von Tein Verwaltungs GmbH",
      "Geschäftsführer der von Tein Verwaltungs GmbH:",
      "Claudia von Tein",
      "",
      "Registergericht: Amtsgericht Frankfurt",
      "Registernummer: HRB 130126",
    ],
  },
  {
    id: "section-impressum-rechtliches",
    leftLabel: "RECHTLICHES",
    heading: "Allgemeine Geschäftsbedingungen",
    paragraphs: [
      <>Unsere allgemeinen Geschäftsbedingungen finden Sie <Link to="/medical/agb" className="text-gray-900 underline underline-offset-2 hover:no-underline">hier</Link>.</>,
      "",
      "Die in unseren Texten verwendete männliche Form gilt für Personen beiderlei Geschlechts.",
    ],
  },
];

export default function ImpressumPage() {
  return (
    <>
      <Hero
        title="Impressum"
        subheading="Angaben gemäß § 5 TMG."
      />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        {SECTIONS.map((section) => (
          <div
            key={section.id}
            id={section.id}
            className="border-b border-gray-100 py-12 md:py-16 first:pt-8"
          >
            <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
              <div className="flex-shrink-0 md:w-36 lg:w-40">
                <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                  {section.leftLabel}
                </span>
              </div>
              <div className="min-w-0 flex-1 max-w-4xl">
                <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                  {section.heading}
                </h2>
                {section.paragraphs.map((p, j) =>
                  p === "" ? (
                    <div key={j} className="h-3" aria-hidden />
                  ) : (
                    <p key={j} className={PARAGRAPH_CLASS}>
                      {p}
                    </p>
                  )
                )}
              </div>
            </div>
          </div>
        ))}

        {/* Bildquellen */}
        <div
          id="section-impressum-bildquellen"
          className="border-b border-gray-100 py-12 md:py-16"
        >
          <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
            <div className="flex-shrink-0 md:w-36 lg:w-40">
              <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                BILDQUELLEN
              </span>
            </div>
            <div className="min-w-0 flex-1 max-w-4xl">
              <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                Bildquellen
              </h2>
              <ul className="mt-6 list-none space-y-1 text-sm leading-relaxed text-gray-700 md:text-base">
                {BILDQUELLEN.map((line, j) => (
                  <li key={j}>{line}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <HighlightedContactSection
          heading="Fragen zum Impressum?"
          description="Wir helfen Ihnen gerne weiter."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-impressum-contact"
        />
      </section>
    </>
  );
}
